import React from "react";
import { logout } from "../Utility";

export default function AppBar({ title, onBack }) {
  return (
    <div className="utr_navbar mb-2">
      <button
        className="button back_button"
        onClick={onBack || undefined}
        style={!onBack ? { visibility: "hidden", pointerEvents: "none" } : {}}
      >
        <img src={require("../../assets/images/back.png")} alt="back" />
      </button>
      <h3>{title}</h3>
      <button className="button" onClick={() => logout()}>
        <img src={require("../../assets/images/power-off.png")} alt="logout" />
      </button>
    </div>
  );
}
